export default {
  newsMailTemplates: []
}
